import {
  CloseOutlined,
  DeploymentUnitOutlined,
  ExperimentOutlined,
  HomeOutlined,
  LogoutOutlined,
  MenuOutlined,
  RobotOutlined,
  SettingOutlined,
  WechatOutlined,
} from "@ant-design/icons";
import { Button, Flex, Layout, Menu, theme, Typography } from "antd";
import { Footer } from "antd/es/layout/layout";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ContainerComponent,
  RandomBackgroundsComponent,
  RowComponent,
} from ".";
import { Logo } from "../assets";
import { LoginRoute } from "../presentation/auth";
import { LaboratoryRoute } from "../presentation/laboratory";
import { WelcomeRoute } from "../presentation/welcome";
import { ShowWorkshopsRoute } from "../presentation/workshops";
import { Roles, useAuth } from "../providers";
const { Header, Sider, Content } = Layout;

export const LayoutComponent = ({ selectedMenuItem, children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [selectedKeys, setSelectedKeys] = useState();
  const {
    token: { borderRadiusLG },
  } = theme.useToken();
  const [collapsed, setCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("collapsed")) ?? true;
  });
  const [isMenuSticky, setIsMenuSticky] = useState(() => {
    return JSON.parse(localStorage.getItem("isMenuSticky")) ?? false;
  });

  const handleCollapse = () => {
    setCollapsed((prev) => {
      localStorage.setItem("collapsed", !prev);
      return !prev;
    });

    setIsMenuSticky((prev) => {
      localStorage.setItem("isMenuSticky", !prev);
      return !prev;
    });
  };

  const handleNavigation = ({ route }) => {
    const currentHash = window.location.hash.replace("#", "");
    if (currentHash !== route) {
      navigate(route);
    }
  };

  useEffect(() => {
    setSelectedKeys(selectedMenuItem);

    return () => {
      setSelectedKeys(null);
    };
  }, [selectedMenuItem]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          padding: 0,
          top: 0,
          width: "100%",
          display: "flex",
          alignItems: "center",
          position: "fixed",
          left: 0,
          zIndex: 1000,
          color: "#fff",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(5px)",
        }}
      >
        <Flex
          style={{
            flex: "auto",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <RowComponent
            style={{ maxWidth: "fit-content", alignItems: "center" }}
          >
            <Button
              type="text"
              icon={collapsed ? <MenuOutlined /> : <CloseOutlined />}
              onClick={() => handleCollapse()}
              style={{
                fontSize: "16px",
                margin: "16px",
                width: 40,
                height: 40,
              }}
            />
            <ContainerComponent>
              <Logo width={150} height={50} />
            </ContainerComponent>
          </RowComponent>
          <Flex style={{ marginRight: 16 }}>
            {user ? (
              <RowComponent style={{ alignItems: "center" }}>
                <Typography.Text level={4} style={{ margin: "16px" }}>
                  {user?.email}
                </Typography.Text>
                <Button
                  type="primary"
                  shape="circle"
                  icon={<LogoutOutlined />}
                  onClick={() => { logout(); navigate(LoginRoute) }}
                  style={{
                    backgroundColor: "#143462",
                    borderColor: "#143462",
                    color: "#ffffff",
                    boxShadow: "none",
                  }}
                />
              </RowComponent>
            ) : (

              <Button
                type="primary"
                onClick={() => navigate(LoginRoute)}
              >
                Iniciar Sesión
              </Button>
            )}
          </Flex>
        </Flex>
      </Header>
      <Layout>
        <Sider
          style={{
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(15, 23, 42, 0.6)",
            height: "calc(100vh - 64px)",
            position: "sticky",
            insetInlineStart: 0,
            top: 64,
            bottom: 0,
            scrollbarWidth: "thin",
            scrollbarGutter: "stable",
          }}
          onMouseEnter={(e) => {
            isMenuSticky && setCollapsed(false);
            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
          }}
          onMouseLeave={(e) => {
            isMenuSticky && setCollapsed(true);
            e.currentTarget.style.boxShadow = "none";
          }}
          trigger={null}
          collapsible
          collapsed={collapsed}
        >
          <div className="demo-logo-vertical" />
          <RandomBackgroundsComponent>
            <Menu
              mode="inline"
              selectedKeys={[selectedKeys]}
              style={{
                borderRight: 0,
                height: "calc(100vh - 64px)",
                backdropFilter: "blur(5px)",
                scrollbarWidth: "thin",
              }}
              onClick={(e) => setSelectedKeys(e.key)}
              items={[
                {
                  key: "welcome",
                  icon: <HomeOutlined />,
                  label: "Bienvenido",
                  onClick: () => {
                    handleNavigation({ route: WelcomeRoute });
                  },
                },
                {
                  key: "use-cases",
                  icon: <RobotOutlined />,
                  label: "Casos de Uso",
                  children: [
                    {
                      key: "catalog",
                      label: "Catálogo",
                      children: [
                        {
                          key: "catalog-agents",
                          label: "Industrias",
                          onClick: () => {
                            handleNavigation({
                              route: "/catalog?filter=industries",
                            });
                          },
                        },
                        {
                          key: "catalog-tools",
                          label: "Tipologías",
                          onClick: () => {
                            handleNavigation({
                              route: "/catalog?filter=typologies",
                            });
                          },
                        },
                      ]
                    },
                    {
                      key: "dev-boost",
                      label: "DevBoost",
                      onClick: () => {
                        handleNavigation({ route: "/dev-boost" });
                      },
                    }
                  ],
                },
                [Roles.ADMIN, Roles.USER].includes(user?.role) && {
                  key: "workshops",
                  icon: <DeploymentUnitOutlined />,
                  label: "Taller",
                  onClick: () => {
                    handleNavigation({ route: ShowWorkshopsRoute });
                  },
                },
                user?.role === Roles.ADMIN && {
                  key: "laboratory",
                  icon: <ExperimentOutlined />,
                  label: "Laboratorio",
                  onClick: () => {
                    handleNavigation({ route: LaboratoryRoute });
                  },
                },
                [Roles.ADMIN, Roles.USER, Roles.COPILOT].includes(user?.role) && {
                  key: "admin",
                  icon: <SettingOutlined />,
                  label: "Admin",
                  onClick: () => {
                    handleNavigation({ route: "/admin" });
                  },
                },
                user?.role === Roles.ADMIN && {
                  key: "factory",
                  icon: <WechatOutlined />,
                  label: "Fábrica",
                  onClick: () => {
                    handleNavigation({ route: "/factory" });
                  },
                },
              ]}
            />
          </RandomBackgroundsComponent>
        </Sider>
        <Layout style={{ marginLeft: "auto", marginTop: 64 }}>
          <RandomBackgroundsComponent>
            <Content
              style={{
                margin: "18px 18px 0",
                overflow: "initial",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  maxWidth: "100%",
                  borderRadius: borderRadiusLG,
                }}
              >
                <Content
                  style={{
                    overflow: "initial",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      maxWidth: "100%",
                      borderRadius: borderRadiusLG,
                    }}
                  >
                    {children}
                  </div>
                </Content>
              </div>
            </Content>
          </RandomBackgroundsComponent>

          <Footer
            style={{
              textAlign: "center",
              width: "100%", // Ensure footer spans full width
            }}
          >
            Sharksia ©{new Date().getFullYear()} Created by Sharksia
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};
